import { render, staticRenderFns } from "./ServiceProviderDetails.vue?vue&type=template&id=534f1e8a&scoped=true&"
import script from "./ServiceProviderDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderDetails.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProviderDetails.vue?vue&type=style&index=0&id=534f1e8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534f1e8a",
  null
  
)

export default component.exports